import GameState from "./game-state";
import { IGame } from "../types/game";
import { CanvasStatus } from "../types/stats";
import PlayerAddBonusState from "./add-bonus-state";
import { PacketTypes } from "../../protocol/types";
import { RespawnPacket } from "../../protocol/packets";

/**
 * WaitRespawnState - Remote player waits for P_RESPAWN packet
 * Matches original: Player_wait_respawn (player.cc:1559-1586)
 * This is ONLY for remote players - local players use DeadWaitState
 */
export default class WaitRespawnState extends GameState {
  private addBonus: boolean;

  constructor(game: IGame, addBonus: boolean = true) {
    super(game);
    this.addBonus = addBonus;
    
    // Match original Player_wait_respawn constructor (player.cc:1559-1562)
    // Original: canvas->idle = 2; canvas->state = Canvas::WAITFORWINNER;
    this.canvas.idle = 2;
    this.canvas.status = CanvasStatus.WAITFORWINNER;
    if (this.game.sendClientState) {
      this.game.sendClientState("waitForWinner");
    }
  }

  enter(): void {
    // Match original Player_wait_respawn constructor - no init() override
  }

  update(frameTime: number): void {
    super.update(frameTime);

    // Check for P_RESPAWN packet (matches original Player_wait_respawn::step() line 1573-1581)
    // Original: Packet_respawn *p=(Packet_respawn *) game->peekpacket(P_RESPAWN);
    //           if(p && p->player==canvas->num_player) { canvas->restart(); ret(); game->removepacket(); }
    if (this.game.peekPacket) {
      const respawnPacket = this.game.peekPacket(
        PacketTypes.RESPAWN
      ) as RespawnPacket | null;
      const myPlayerNumber = this.canvas.numPlayer;
      
      if (respawnPacket && respawnPacket.numPlayer === myPlayerNumber) {
        // Call canvas.restart() to clear the board (matches original line 1575)
        this.canvas.restart();
        
        this.ret(); // Mark as done (executor will remove this state)
        this.game.removePacket?.();
        if (this.game.sendClientState) {
          this.game.sendClientState("playing");
        }
        return;
      }
    }

    // Check for bonus while waiting (matches original line 1582-1584)
    // Original: else { if(canvas->bonus && !canvas->bon[0].blind_time && add_bonus) call(new Player_add_bonus(canvas)); }
    if (this.canvas.bonus > 0 && this.canvas.bon[0] && !this.canvas.bon[0].blind_time && this.addBonus) {
      this.game.pushState(new PlayerAddBonusState(this.game));
    }
  }

  toString(): string {
    return "Wait Respawn (Remote)";
  }
}

